<div class="analytics-details-view flex min-h-0 flex-1 flex-col" [ngSwitch]="deliverableType()">
  <app-title-post-analytics
    class="analytics-details-view__content"
    *ngSwitchCase="EDeliverableType.title"
    [deliverableForm]="deliverableForm()"
    [deliverableId]="deliverableId()"
    [executionAnalytics]="executionAnalytics()"
    [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
  />
  <app-caption-post-analytics
    class="analytics-details-view__content"
    *ngSwitchCase="EDeliverableType.caption"
    [deliverableForm]="deliverableForm()"
    [deliverableId]="deliverableId()"
    [executionAnalytics]="executionAnalytics()"
    [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
  />
  <app-hashtag-post-analytics
    class="analytics-details-view__content"
    *ngSwitchCase="EDeliverableType.hashTag"
    [deliverableForm]="deliverableForm()"
    [deliverableId]="deliverableId()"
    [executionAnalytics]="executionAnalytics()"
    [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
  />
  <app-mention-post-analytics
    class="analytics-details-view__content"
    *ngSwitchCase="EDeliverableType.mention"
    [deliverableForm]="deliverableForm()"
    [deliverableId]="deliverableId()"
    [executionAnalytics]="executionAnalytics()"
    [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
  />
  <app-message-post-analytics
    class="analytics-details-view__content"
    *ngSwitchCase="EDeliverableType.message"
    [deliverableForm]="deliverableForm()"
    [deliverableId]="deliverableId()"
    [executionAnalytics]="executionAnalytics()"
    [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
  />
  <app-description-post-analytics
    class="analytics-details-view__content"
    *ngSwitchCase="EDeliverableType.description"
    [deliverableForm]="deliverableForm()"
    [deliverableId]="deliverableId()"
    [executionAnalytics]="executionAnalytics()"
    [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
  />
  <app-talking-points-post-analytics
    class="analytics-details-view__content"
    *ngSwitchCase="EDeliverableType.talkingPoint"
    [deliverableForm]="deliverableForm()"
    [deliverableId]="deliverableId()"
    [executionAnalytics]="executionAnalytics()"
    [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
  />
  <app-talking-point-ai-post-analytics
    class="analytics-details-view__content"
    *ngSwitchCase="EDeliverableType.talkingPointAi"
    [deliverableForm]="deliverableForm()"
    [deliverableId]="deliverableId()"
    [executionAnalytics]="executionAnalytics()"
    [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
  />
  <app-text-tracking-post-analytics
    class="analytics-details-view__content"
    *ngSwitchCase="EDeliverableType.textTracking"
    [deliverableForm]="deliverableForm()"
    [deliverableId]="deliverableId()"
    [executionAnalytics]="executionAnalytics()"
    [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
  />
  <app-audio-tracking-post-analytics
    class="analytics-details-view__content"
    *ngSwitchCase="EDeliverableType.audioTracking"
    [deliverableForm]="deliverableForm()"
    [deliverableId]="deliverableId()"
    [executionAnalytics]="executionAnalytics()"
    [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
  />
  <app-content-post-analytics
    class="analytics-details-view__content"
    *ngSwitchCase="EDeliverableType.content"
    [deliverableForm]="deliverableForm()"
    [deliverableId]="deliverableId()"
    [executionAnalytics]="executionAnalytics()"
    [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
  />
  <app-visual-post-analytics
    class="analytics-details-view__content"
    *ngSwitchCase="EDeliverableType.visual"
    [deliverableForm]="deliverableForm()"
    [deliverableId]="deliverableId()"
    [executionAnalytics]="executionAnalytics()"
    [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
  />
  <app-product-placement-post-analytics
    class="analytics-details-view__content"
    *ngSwitchCase="EDeliverableType.productPlacement"
    [deliverableForm]="deliverableForm()"
    [deliverableId]="deliverableId()"
    [executionAnalytics]="executionAnalytics()"
    [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
  />
  <app-custom-post-analytics
    class="analytics-details-view__content"
    *ngSwitchCase="EDeliverableType.custom"
    [deliverableForm]="deliverableForm()"
    [deliverableId]="deliverableId()"
    [executionAnalytics]="executionAnalytics()"
    [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
  />
  <ng-content />
</div>
